var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEmployee)?_c('benefit-list'):_c('benefit-box')}
var staticRenderFns = []

export { render, staticRenderFns }